import React, { useEffect, useState, lazy } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const PACK = 'MEGAPACK Química Visual';
const purchases = [{
  name: 'María G',
  code: 'co',
  location: 'Bogotá, Colombia',
  pack: PACK,
  time: 'hace 2 min'
}, {
  name: 'Juan Q',
  code: 'pe',
  location: 'Lima, Perú',
  pack: PACK,
  time: 'hace 4 min'
}, {
  name: 'Camila M',
  code: 'cl',
  location: 'Santiago, Chile',
  pack: PACK,
  time: 'hace 6 min'
}, {
  name: 'Andrés H',
  code: 'mx',
  location: 'Ciudad de México, México',
  pack: PACK,
  time: 'hace 8 min'
}, {
  name: 'Luciana R',
  code: 'co',
  location: 'Medellín, Colombia',
  pack: PACK,
  time: 'hace 9 min'
}, {
  name: 'Diego F',
  code: 'uy',
  location: 'Montevideo, Uruguay',
  pack: PACK,
  time: 'hace 11 min'
}, {
  name: 'Sofía V',
  code: 'ec',
  location: 'Quito, Ecuador',
  pack: PACK,
  time: 'hace 13 min'
}, {
  name: 'Martín L',
  code: 'ar',
  location: 'Buenos Aires, Argentina',
  pack: PACK,
  time: 'hace 15 min'
}, {
  name: 'Valentina C',
  code: 'bo',
  location: 'La Paz, Bolivia',
  pack: PACK,
  time: 'hace 17 min'
}, {
  name: 'Gustavo G',
  code: 'py',
  location: 'Asunción, Paraguay',
  pack: PACK,
  time: 'hace 19 min'
}, {
  name: 'Daniela T',
  code: 'mx',
  location: 'Guadalajara, México',
  pack: PACK,
  time: 'hace 21 min'
}, {
  name: 'Esteban N',
  code: 'ec',
  location: 'Guayaquil, Ecuador',
  pack: PACK,
  time: 'hace 23 min'
}, {
  name: 'Gabriela P',
  code: 'co',
  location: 'Cali, Colombia',
  pack: PACK,
  time: 'hace 25 min'
}, {
  name: 'Fernando A',
  code: 'pe',
  location: 'Arequipa, Perú',
  pack: PACK,
  time: 'hace 27 min'
}, {
  name: 'Carolina J',
  code: 'cr',
  location: 'San José, Costa Rica',
  pack: PACK,
  time: 'hace 29 min'
}, {
  name: 'Javier O',
  code: 'ar',
  location: 'Córdoba, Argentina',
  pack: PACK,
  time: 'hace 31 min'
}, {
  name: 'Mariana D',
  code: 'cl',
  location: 'Valparaíso, Chile',
  pack: PACK,
  time: 'hace 33 min'
}, {
  name: 'Carlos E',
  code: 've',
  location: 'Caracas, Venezuela',
  pack: PACK,
  time: 'hace 35 min'
}, {
  name: 'Verónica S',
  code: 'mx',
  location: 'Puebla, México',
  pack: PACK,
  time: 'hace 37 min'
}, {
  name: 'Lucía F',
  code: 'es',
  location: 'Madrid, España',
  pack: PACK,
  time: 'hace 39 min'
}];
export function PurchaseToast() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setHasScrolled(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (!hasScrolled) return;
    const showNext = () => {
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
      setCurrentIndex(prev => (prev + 1) % purchases.length);
    };
    const interval = setInterval(showNext, 12000);
    // Show first one immediately after scroll trigger
    showNext();
    return () => clearInterval(interval);
  }, [hasScrolled]);
  const currentPurchase = purchases[currentIndex];
  return <AnimatePresence data-id="element-253" data-mp="301tld1f80lus">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: -50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -50
    }} className="fixed top-4 left-4 right-4 md:left-1/2 md:-translate-x-1/2 z-[100] bg-white border border-blue-100 p-3 md:p-4 rounded-xl shadow-2xl flex items-center gap-3 md:gap-4 max-w-sm mx-auto" data-id="element-254" data-mp="302wab3szge82">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-xs md:text-base shrink-0" data-id="element-255" data-mp="3j0pee9fceu71">
            {currentPurchase.name.charAt(0)}
          </div>
          <div className="flex-1" data-id="element-256" data-mp="fc48gty2va4q">
            <div className="flex items-center justify-between" data-id="element-257" data-mp="fd6uookggoeb">
              <p className="text-[11px] md:text-sm font-bold text-slate-900 flex items-center gap-1.5" data-id="element-258" data-mp="2mvfjaflpsbii">
                <img src={`https://flagcdn.com/w40/${currentPurchase.code}.png`} srcSet={`https://flagcdn.com/w80/${currentPurchase.code}.png 2x`} alt={`Bandera de ${currentPurchase.location}`} width={20} height={14} loading="lazy" className="w-5 h-auto rounded-[2px] shadow-sm shrink-0" data-id="element-259" data-mp="2itc3jes0ikrf" />
                {currentPurchase.location}
              </p>
              <button onClick={() => setIsVisible(false)} className="text-slate-400 hover:text-slate-600" data-id="element-260" data-mp="36l92i5ad5ib4">
                <X size={14} data-id="element-261" data-mp="31mfsimuac9fp" />
              </button>
            </div>
            <p className="text-xs text-slate-600" data-id="element-262" data-mp="2wrsbta5iwjbo">
              <span className="font-bold text-slate-900" data-id="element-263" data-mp="2rus4yx0uncji">
                {currentPurchase.name}
              </span>{' '}
              adquirió el{' '}
              <span className="text-blue-600 font-bold" data-id="element-264" data-mp="3paz0f19fak79">
                {currentPurchase.pack}
              </span>
            </p>
            <p className="text-[10px] text-green-600 font-bold mt-1 flex items-center gap-1" data-id="element-265" data-mp="3ru3sx3d3zm5k">
              <span className="inline-block w-1.5 h-1.5 bg-green-500 rounded-full" data-id="element-266" data-mp="nswxlmyhbl3"></span>
              Compra verificada • {currentPurchase.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}